import GridTexsEntrantController from './grid-texs-entrant.controller';
import Template from './grid-texs-entrant.html';

export default {
	bindings: {
		loading: '=',
		table: '=',
		pipe: '@'
	},
	controller: GridTexsEntrantController,
	template: Template
};
